import { useRouterQueryParams } from "@circle-react/hooks/useRouterQueryParams";

export const useIsIframeEmbed = () => {
  const { iframe } = useRouterQueryParams();

  return iframe === "true";
};
